import React, { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Sidebar from '../components/layout/Sidebar';
import Header from '../components/layout/Header';
import DashboardOverview from '../components/dashboard/DashboardOverview';
import IndentModule from '../components/indents/IndentModule';
import PurchaseModule from '../components/purchase/PurchaseModule';
import StockModule from '../components/stock/StockModule';
import ProductionModule from '../components/production/ProductionModule';
import ProductMaster from '../components/products/ProductMaster';
import DispatchModule from '../components/dispatches/DispatchModule';
import SalesModule from '../components/sales/SalesModule';
import ReportsModule from '../components/reports/ReportsModule';
import BranchManager from '../components/settings/BranchManager';
import SettingsPage from '../components/settings/SettingsPage';
import ForecastModule from '../components/forecast/ForecastModule';
import ApprovalsModule from '../components/approvals/ApprovalsModule';
import BOMModule from '../components/bom/BOMModule';
import PlanningModule from '../components/planning/PlanningModule';
import SiteProjectModule from '../components/projects/SiteProjectModule';
import InwardModule from '../components/inward/InwardModule';

const DashboardPage = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const user = JSON.parse(localStorage.getItem('prismoline_user') || '{}');

  if (!user.email) return <Navigate to="/login" replace />;

  return (
    <div className="flex h-screen bg-gray-50 overflow-hidden">
      <Sidebar collapsed={sidebarCollapsed} onToggle={() => setSidebarCollapsed(!sidebarCollapsed)} user={user} />
      <div className={`flex-1 flex flex-col overflow-hidden transition-all duration-300 ${sidebarCollapsed ? 'ml-[68px]' : 'ml-[250px]'}`}>
        <Header user={user} />
        <main className="flex-1 overflow-y-auto">
          <Routes>
            <Route index element={<DashboardOverview />} />
            <Route path="approvals" element={<ApprovalsModule />} />
            <Route path="boms" element={<BOMModule />} />
            <Route path="indents" element={<IndentModule />} />
            <Route path="purchase" element={<PurchaseModule />} />
            <Route path="inwards" element={<InwardModule />} />
            <Route path="stock" element={<StockModule />} />
            <Route path="products" element={<Navigate to="/dashboard/settings" replace />} />
            <Route path="production" element={<ProductionModule />} />
            <Route path="dispatches" element={<DispatchModule />} />
            <Route path="site-projects" element={<SiteProjectModule />} />
            <Route path="sales" element={<SalesModule />} />
            <Route path="reports" element={<ReportsModule />} />
            <Route path="planning" element={<PlanningModule />} />
            <Route path="forecast" element={<ForecastModule />} />
            <Route path="settings" element={<SettingsPage />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </main>
      </div>
    </div>
  );
};

export default DashboardPage;
